// extracted by mini-css-extract-plugin
export default {"privacyPolicySection":"PrivacyPolicy_privacyPolicySection__3SC9b"};